import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.ITEM_PROCESSO.BUSCAR_ITENS_PROCESSOS_LISTAGEM]({ state }) {
		const { filtro, paginacao } = state
		const { data } = await api.itemProcesso.buscarListagem(filtro, paginacao)
		return data
	},
	async [actionTypes.ITEM_PROCESSO.EDITAL.BUSCAR_EDITAIS_POR_FILTRO]({ state }, filtro) {
		const { paginacao } = state.edital
		const novoFiltro = {
			idProcesso: filtro.idProcesso,
			idsFornecedores: filtro.idsFornecedores,
			editaisSelecionados: filtro.numeroEditais,
			numeroEditais: [],
			idsTipos: filtro.idsTipos,
			numeroEdital: filtro.numeroEdital,
		}
		const { data } = await api.itemProcesso.buscarEditaisPorFiltro(novoFiltro, paginacao)
		return data
	},

	async [actionTypes.ITEM_PROCESSO.BUSCAR_ITENS_PROCESSOS_POR_FORNECEDOR](context, objBusca) {
		const { filtro, paginacao } = objBusca
		const { data } = await api.itemProcesso.buscarItemProcessoPorFornecedor(filtro, paginacao)
		return data
	},
}
